import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
  ariaLabel?: string;
}
const sizeStyles: Record<NonNullable<CtaButtonProps['size']>, string> = {
  md: 'px-6 py-3 text-sm sm:text-base',
  lg: 'px-8 py-4 text-base sm:text-lg',
  xl: 'px-8 py-5 text-lg sm:text-2xl'
};
export function CtaButton({
  children,
  size = 'lg',
  href = '#oferta',
  className = '',
  ariaLabel
}: CtaButtonProps) {
  return <a href={href} aria-label={ariaLabel} className={`cta-glow group inline-flex items-center justify-center gap-2 rounded-xl bg-orange-500 font-display uppercase tracking-tight text-white transition-all duration-200 hover:bg-orange-400 hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-300 ${sizeStyles[size]} ${className}`} data-id="element-46">
      <span className="text-center leading-tight" data-id="element-47">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-48" />
    </a>;
}